<template>
  <div class="yxtbiz-trainings-standard">
    <div
      v-if="detail.name"
      class="training-standard__header"
    >
      <div class="training-standard__header__title yxt-weight-5 lh22">
        {{ $t('pc_gwnl_training_standards') }}
      </div>
      <div class="training-standard__header__subtitle">
        {{ $t('pc_gwnl_training_standard_title') }}
      </div>
    </div>
    <div
      class="training-standard__content pt40 pb20 pl24 pr24"
    >
      <div
        v-if="!detail.name"
        class="training-standard__empty"
      >
        <div class="mb24">
          <div class="empty-title">
            {{ $t('pc_gwnl_training_standard_title') }}
          </div>
          <div class="empty-subtitle mt12 text-center">
            {{ $t('pc_gwnl_training_standard_subtitle') }}
          </div>
        </div>
        <div class="flex">
          <div
            v-for="item in emptyArr"
            :key="item.title"
            class="pl24 pt32 empty-card"
            :class="item.bgimg"
          >
            <div class="empty-card-title mb8">
              {{ item.title }}
            </div>
            <div class="empty-card-subtitle mb24 mr22 nowrap-2">
              {{ item.subTitle }}
            </div>
            <yxt-image
              :src="$staticBaseUrl + 'ufd/c4d5f9/gwnl/pc/img/' + item.imgSrc"
            />
          </div>
        </div>
        <div class="mt32">
          <!-- 项目已结束，置灰不可选择模型 -->
          <yxt-tooltip
            v-if="publishStatus === 3"
            effect="dark"
            placement="top"
            :content="$t('pc_gwnl_web_trainingEnded'/* 项目已结束 */)"
          >
            <!-- tooltip 内不支持 disabled form 元素，请在 disabled form 元素外层添加一层包裹元素。 -->
            <div>
              <yxt-button
                type="primary"
                disabled
              >
                {{ $t('pc_gwnl_jq_selectSkillModel'/* 选择能力模型 */) }}
              </yxt-button>
            </div>
          </yxt-tooltip>
          <yxt-button
            v-else
            type="primary"
            @click="selectModel"
          >
            {{ $t('pc_gwnl_jq_selectSkillModel') }}
          </yxt-button>
        </div>
      </div>
      <div
        v-else-if="detail.name"
        class="training-standard__models"
      >
        <div
          class="flex-align-center mb20 ht32"
          :class="{ 'mb28': isShowSkillLevel && toggleRadio === $t('pc_gwnl_web_radarShow') }"
        >
          <span class="standard-yxt-form-item ellipsis mr12">
            {{ detail.name }}
          </span>
          <template v-if="publishStatus > 2">
            <yxt-tooltip
              effect="dark"
              :content="$t('pc_gwnl_web_trainingEnded'/* 项目已结束 */)"
              placement="top"
            >
              <span class="re-change">
                {{ $t('pc_gwnl_training_re_change') }}
              </span>
            </yxt-tooltip>
          </template>
          <yxt-button
            v-else
            type="text"
            @click="selectVisibleChange"
          >
            {{ $t('pc_gwnl_training_re_change') }}
          </yxt-button>
        </div>
        <preview-skills
          class="gwnl-preview-d_jump"
          :list="detail.skillCatalogModels"
          :show-header="false"
          :show-behavior="true"
          :enable-skill-level="detail.enableSkillLevel === 1"
          :enable-excellent-level="detail.enableExcellentLevel"
          :enable-weight-switch="detail.enableWeightSwitch"
        />
      </div>
    </div>
    <yxtbiz-model-selector
      ref="modelSelector"
      :source="-1"
      :type="2"
      :default-value="modelId"
      @success="selectModelSuccess"
      @preview="preview"
    />
  </div>
</template>

<script>
import previewSkills from 'yxt-biz-pc/packages/ability-preview/src/components/preview-skills';
import { getSkillTemplateDetail } from './service';

export default {
  name: 'YxtbizTrainingsStandard',
  components: {
    previewSkills
  },
  props: {
    skillModelId: {
      type: String,
      default: ''
    },
    publishStatus: Number // 状态(0-未配置, 1-待发布, 2-已发布,3-已结束)
  },
  data() {
    return {
      modelId: '',
      detail: {},
      emptyArr: [
        {
          title: this.$t('pc_gwnl_training_standard_first_title'),
          subTitle: this.$t('pc_gwnl_training_standard_first_subtitle'),
          imgSrc: 'train_first_con_1x.png',
          bgimg: 'empty-first-card'
        },
        {
          title: this.$t('pc_gwnl_training_standard_second_title'),
          subTitle: this.$t('pc_gwnl_training_standard_second_subtitle'),
          imgSrc: 'train_second_con_1x.png',
          bgimg: 'empty-second-card'
        },
        {
          title: this.$t('pc_gwnl_training_standard_third_title'),
          subTitle: this.$t('pc_gwnl_training_standard_third_subtitle'),
          imgSrc: 'train_third_con_1x.png',
          bgimg: 'empty-third-card'
        }
      ],
      toggleRadio: this.$t('pc_gwnl_web_radarShow')
    };
  },
  computed: {
    isShowSkillLevel() {
      const skillCatalogModels = this.detail.skillCatalogModels || [];
      const skill = (skillCatalogModels.length && ((skillCatalogModels[0].skillModelClassifications.length && skillCatalogModels[0].skillModelClassifications[0].skill) || (skillCatalogModels[0].skillModelClassifications.length && skillCatalogModels[0].skillModelClassifications[0].skillModelMaps.length && skillCatalogModels[0].skillModelClassifications[0].skillModelMaps[0].skill))) || undefined;
      return skill && skill.skillLevelMaps && skill.skillLevelMaps.length;
    }
  },
  watch: {
    skillModelId: {
      handler(val) {
        !!val & this.getTraining();
      },
      immediate: true
    }
  },
  methods: {
    getTraining() {
      if (this.skillModelId) {
        this.getTemplateDetail(this.skillModelId, true);
      }
    },
    selectVisibleChange(value) {
      if (value) this.selectModel();
    },
    selectModel() {
      this.$refs.modelSelector.open();
    },
    selectModelSuccess(modelId) {
      if (!modelId) { // 没有选择能力模型点击确认按钮
        this.detail = {};
        this.modelId = '';
        this.$emit('success', null);
        return;
      }
      this.getTemplateDetail(modelId, false);
    },
    getTemplateDetail(modelId, isFirst) {
      this.modelId = modelId;
      getSkillTemplateDetail(modelId).then((res) => {
        this.detail = res;
        if (!isFirst) {
          this.$emit('success', res);
        }
      }).catch((err) => {
        this.$message.error(err.error.message);
      });
    },
    preview(id) {
      this.$emit('preview', id);
    }
  }
};
</script>
